jQuery(document).ready(function ($) {

  $breakpoint_grid2slides = 992;
  settings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
					// rows: 2,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
					//rows: 2,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };

  $slick_slider = $('.team-grid-slider');
  $slick_slider.slick(settings);

  var setGridOrSlides = function(){
    if ($(window).width() >= $breakpoint_grid2slides) {
      if ($slick_slider.hasClass('slick-initialized')) {
        $slick_slider.slick('unslick');
      }
      return;
    }

    if (!$slick_slider.hasClass('slick-initialized')) {
      console.log('init');
      return $slick_slider.slick(settings);
    }
  };

  $(window).on('resize', function() {
    setGridOrSlides();
  });

  //init
  setGridOrSlides();
});